<template>
  <div>
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center">
          <v-progress-circular indeterminate color="white" size="40" class="mb-4" />
          <span>Aguarde...</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-list-group prepend-icon="mdi-account-tie">
      <template v-slot:activator>
        <v-list-item-title>SERVIDOR</v-list-item-title>
      </template>

      <v-list-item v-for="menu in dadosmenu" :key="menu.action" @click="acao(menu.action)">
        <v-list-item-icon>
          <v-icon :color="menu.colorIcon">{{ menu.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ menu.title }}</v-list-item-title>
      </v-list-item>
    </v-list-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import filtros from "@/libs/filters";
import ServidorServices from "@/services/rh/ServidorServices";
import CredenciamentoServices from "@/services/acesso/CredenciamentoServices";
import InscricaoRemocaoServices from "@/services/remocao/InscricaoRemocaoServices";
import RemocaoServices from "@/services/rh/RemocaoServices";
export default {
  name: "MenuServidor",
  data: () => ({
    loading: false,
    menus: [
      { title: "Dados Pessoais", icon: "mdi-account-circle", action: 1, colorIcon: "blue" },
      { title: "Perfil Usuario", icon: "mdi-face-man-profile", action: 2, colorIcon: "blue" },
      { title: "Banco de Horas", icon: "mdi-clock-check-outline", action: 4, colorIcon: "blue" },
      { title: "Avaliações", icon: "mdi-check", action: 5, colorIcon: "blue" },
      { title: "Andamento Avaliação Família", icon: "mdi-chart-box-outline", action: 6, colorIcon: "blue" },
      { title: "Análise Avaliação Responsáveis", icon: "mdi-account-check-outline", action: 7, colorIcon: "blue" },
    ],
  }),
  components: {},
  filters: filtros,
  computed: {
    ...mapGetters({
      processos: "config/getProcessos",
    }),
    dadosLogado() {
      return this.$store.getters["config/getUsuarioLogado"];
    },
    dadosmenu() {
      return this.menus;
    },
    processoInscricao() {
      const pro = this.processos.find((p) => p.id == 1);
      return pro;
    },
  },
  methods: {
    async acao(opcao) {
      switch (opcao) {
        case 1:
          this.loading = true;
          await ServidorServices.getServidor({ pkpessoa: this.dadosLogado.pkpessoa });
          this.loading = false;
          this.$router.push("/dados-pessoais");
          break;
        case 2:
          this.loading = true;

          await CredenciamentoServices.buscarUsuario(this.dadosLogado.id_usuario);
          this.loading = false;
          this.$router.push("/perfil-usuario");
          break;
        case 4:
          this.$router.push("/banco-horas");
          break;
        case 5:
          this.$router.push("/avaliacao-servidor");
          break;
        case 6:
          this.$router.push("/andamento-avaliacao-familia");
          break;
        case 7:
          this.$router.push("/analise-avaliacao-responsavel");
          break;
        case 3: {
          this.loading = true;

          await InscricaoRemocaoServices.dadosInscricaoUsuario({
            pkpessoa: this.dadosLogado.pkpessoa,
            ano: this.processoInscricao.ano,
          });
          const inscricao = this.$store.getters["remocao/getInscricaoUsuario"];

          const cpf = inscricao.cabecalho.cpf || 0;
          await RemocaoServices.listarUploadsInscricao(this.processoInscricao.ano, cpf);
          await RemocaoServices.bootstrapListarDatasDistribuicao(this.processoInscricao.ano);
          this.loading = false;
          this.$router.push("/remocao-dados-inscricao");
          break;
        }
      }
      this.$store.commit("config/setSidebarOpen", false);
    },
  },
  mounted: function () {
    // Verifica se existe processo com id == 1
    if (this.processos && Array.isArray(this.processos)) {
      const existeProcesso1 = this.processos.some((p) => p.id === 1);
      if (existeProcesso1) {
        this.menus.push({ title: "Remoção/Distribuição", icon: "mdi-swap-vertical", action: 3, colorIcon: "blue" }),
          this.processos.find((p) => p.id === 1);

        // Aqui você pode executar alguma ação se necessário
      }
    }
  },
};
</script>
